import { render, staticRenderFns } from "./UpdateSupplierDialog.vue?vue&type=template&id=4f83eb2e&scoped=true&lang=pug&"
import script from "./UpdateSupplierDialog.vue?vue&type=script&lang=ts&"
export * from "./UpdateSupplierDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f83eb2e",
  null
  
)

export default component.exports